import { Card, Name } from "../../../components/Parts";
import styled from "styled-components";
import useTranslations from "../../../hooks/useTranslations";
const Inner = styled.div`
  padding: 16px;
`;
const NotStarted = () => {
  const translations = useTranslations();
  return (
    <Inner>
      <Card>
        <Name>{translations["Varžybos neprasidėjo"]}</Name>
      </Card>
    </Inner>
  );
};

export default NotStarted;
